import RouteViewComponent from "./routerView";

const routeAccountReceivable = [
  {
    path: "test",
    name: "ar_payment_test",
    // meta: { url: "/", parent: "" },
    // redirect: "/pages/login"
    component: () => import("@/views/oms/finance/ar_payment/index.vue"),
  },
  {
    path: "payment-received",
    name: "ar_payment_payment_received",
    component: RouteViewComponent,
    children: [
      {
        path: "/",
        name: "ar_payment_payment_received.index",
        component: () =>
          import("@/views/oms/finance/ar_payment/payment-received.vue"),
      },
      {
        path: "create",
        name: "ar_payment_payment_received.create",
        component: () =>
          import("@/views/oms/finance/ar_payment/payment-received/form.vue"),
      },
      {
        path: "form/:id",
        name: "ar_payment_payment_received.form",
        component: () =>
          import("@/views/oms/finance/ar_payment/payment-received/form.vue"),
      },
      {
        path: "edit/:id",
        name: "ar_payment_payment_received.edit",
        component: () =>
          import("@/views/oms/finance/ar_payment/payment-received/form.vue"),
      },
    ],
    // meta: { url: "/", parent: "" },
    // redirect: "/pages/login"
  },
  {
    path: "payment",
    name: "payment",
    component: RouteViewComponent,
    children: [
      {
        path: "form/:id",
        name: "payment.view",
        component: () => import("@/views/oms/finance/payment/form.vue"),
      },
      {
        path: "edit/:id",
        name: "payment.edit",
        component: () => import("@/views/oms/finance/payment/form.vue"),
      },
      {
        path: "payment-cit/form/:id",
        name: "payment-cit.view",
        component: () => import("@/views/oms/finance/payment/form.vue"),
      },
      {
        path: "payment-cit/edit/:id",
        name: "payment-cit.edit",
        component: () => import("@/views/oms/finance/payment/form.vue"),
      },
    ],
    // meta: { url: "/", parent: "" },
    // redirect: "/pages/login"
  },
  {
    path: "cn-temporary",
    name: "cn_temporary",
    component: RouteViewComponent,
    children: [
      {
        path: "",
        name: "cn_temporary.index",
        component: () =>
          import("@/views/oms/finance/credit_note_temporary/index.vue"),
      },
      {
        path: "create",
        name: "cn_temporary.create",
        component: () =>
          import("@/views/oms/finance/credit_note_temporary/form.vue"),
      },
      {
        path: "view/:id",
        name: "cn_temporary.view",
        component: () =>
          import("@/views/oms/finance/credit_note_temporary/form.vue"),
      },
      {
        path: "edit/:id",
        name: "cn_temporary.edit",
        component: () =>
          import("@/views/oms/finance/credit_note_temporary/form.vue"),
      },
    ],
  },
  {
    path: "billing-cmi",
    name: "billing-cmi",
    component: RouteViewComponent,
    children: [
      {
        path: "",
        name: "billing-cmi.index",
        component: () => import("@/views/oms/finance/billing-cmi/index.vue"),
      },
    ],
  },
  {
    path: "payment-received-cross-ba",
    name: "payment_received_cross_ba",
    component: RouteViewComponent,
    children: [
      {
        path: "",
        name: "payment_received_cross_ba.index",
        component: () =>
          import("@/views/oms/finance/payment_receive_cross_ba/index.vue"),
      },
      {
        path: "create",
        name: "payment_received_cross_ba.create",
        component: () =>
          import(
            "@/views/oms/finance/payment_receive_cross_ba/payment-received/form.vue"
          ),
      },
      {
        path: "form/:id?",
        name: "payment_received_cross_ba.form",
        component: () =>
          import(
            "@/views/oms/finance/payment_receive_cross_ba/payment-received/form.vue"
          ),
      },
      {
        path: "edit/:id",
        name: "payment_received_cross_ba.edit",
        component: () =>
          import(
            "@/views/oms/finance/payment_receive_cross_ba/payment-received/form.vue"
          ),
      },
      {
        path: "view/:id",
        name: "payment_received_cross_ba.view",
        component: () =>
          import(
            "@/views/oms/finance/payment_receive_cross_ba/payment-received/form_view.vue"
          ),
      },
    ],
    meta: {
      breadcrumb: [
        { title: "Finance", url: "/finance" },
        { title: "Account Receivable", url: "/finance/account-receivable" },
        { title: "Payment Received Cross BA", active: true },
      ],
    },
  },
];

export default routeAccountReceivable;
